import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { formatSgd } from "../../lib/utils";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../ui/table";
import { ShieldAlert, ArrowRight } from "lucide-react";

const LIKELIHOOD_TONE = {
  High: "text-[#00E65B]", Medium: "text-[#FFB800]", Low: "text-red-500", "Needs More Information": "text-muted-foreground",
};
const STATUS_LABEL = { not_assessed: "Not assessed", recommended: "Recommended", tagged: "Tagged", case_created: "Case created" };

export default function MatchedOpportunitiesTab({ onOpenCase }) {
  const [rows, setRows] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/green-finance/matched-opportunities").then((r) => setRows(r.data.opportunities)); }, []);

  return (
    <div className="space-y-3" data-testid="gf-matched-tab">
      <div className="rounded-sm border border-border bg-surface-hover/40 p-2.5 text-[11px] text-muted-foreground flex gap-2">
        <ShieldAlert className="h-3.5 w-3.5 shrink-0 mt-0.5 text-[#FFB800]" />
        Matches and approval likelihood are indicative platform assessments only — not bank approvals or financial advice.
      </div>
      <div className="card-flat overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Initiative</TableHead><TableHead>Type</TableHead><TableHead>Owner</TableHead>
            <TableHead className="text-right">Investment</TableHead><TableHead>Top offer</TableHead>
            <TableHead className="text-right">Match</TableHead><TableHead>Likelihood</TableHead>
            <TableHead>Status</TableHead><TableHead></TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.initiative_id} data-testid={`matched-row-${r.initiative_id}`}>
                <TableCell className="text-sm font-medium">{r.initiative_name}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{(r.initiative_type || "").replace(/_/g, " ")}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{r.owner}</TableCell>
                <TableCell className="text-right font-mono text-xs">{r.investment_required ? formatSgd(r.investment_required) : "—"}</TableCell>
                <TableCell className="text-xs">{r.top_offer ? `${r.top_offer_bank} · ${r.top_offer}` : "—"}</TableCell>
                <TableCell className="text-right font-mono text-xs">{r.match != null ? r.match : (r.match_score != null ? `${r.match_score}/100` : "—")}</TableCell>
                <TableCell className={`text-xs ${LIKELIHOOD_TONE[r.approval_likelihood] || ""}`}>{r.approval_likelihood || "—"}</TableCell>
                <TableCell><Badge variant="outline" className="text-[9px]">{STATUS_LABEL[r.match_status] || r.match_status}</Badge></TableCell>
                <TableCell className="text-right">
                  {r.green_financing_case_id
                    ? <Button size="sm" variant="outline" onClick={() => onOpenCase && onOpenCase(r.green_financing_case_id)} data-testid={`open-case-${r.initiative_id}`}>Open case <ArrowRight className="h-3 w-3" /></Button>
                    : <Button size="sm" variant="ghost" onClick={() => nav(`/initiatives`)} className="text-accent">Open initiative</Button>}
                </TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={9} className="text-center text-sm text-muted-foreground py-6">No initiatives assessed for financing yet. Run a match from an initiative’s “Green Financing Matches” tab.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
